import React, { useState } from "react";
import { format } from "date-fns";
import {
  FaCheckCircle,
  FaHourglassHalf,
  FaTimesCircle,
  FaBan,
  FaSpinner,
  FaTimes,
  FaTicketAlt,
  FaClock,
  FaUser,
  FaUserTie,
  FaStar
} from "react-icons/fa";
import styles from "./Card.module.css";

function Card({ ticket, allticketced }) {
  const [showModal, setShowModal] = useState(false);

  if (!ticket) return null;

  const formatFecha = (fecha) => {
    try {
      return format(new Date(fecha), "dd/MM/yyyy HH:mm");
    } catch (e) {
      return fecha;
    }
  };

  const getEstadoInfo = (estadoId) => {
    switch (estadoId) {
      case 1:
        return { descripcion: "Creado", icon: <FaCheckCircle className={styles.iconCreated} />, className: styles.createdBadge };
      case 2:
        return { descripcion: "En proceso", icon: <FaSpinner className={styles.iconInProcess} />, className: styles.processBadge };
      case 3:
        return { descripcion: "Pendiente", icon: <FaHourglassHalf className={styles.iconPending} />, className: styles.pendingBadge };
      case 4:
        return { descripcion: "Resuelto", icon: <FaTimesCircle className={styles.iconClosed} />, className: styles.resolvedBadge };
      case 5:
        return { descripcion: "Cerrado", icon: <FaCheckCircle className={styles.iconResolved} />, className: styles.closedBadge };
      case 6:
        return { descripcion: "Cancelado", icon: <FaBan className={styles.iconCancelled} />, className: styles.cancelledBadge };
      default:
        return { descripcion: "Desconocido", icon: null, className: "" };
    }
  };

  const estado = getEstadoInfo(ticket.EstadoId);

  /** 🔹 historial del ticket */
  const historial =
    allticketced
      ?.flatMap(item => item.tickets || [])
      .filter(t => t.TicketId === ticket.TicketId) || [];

  const ticketResuelto = historial.find(
    item => item.EstadoId === 2 && item.Usuario
  );

  const nombreTecnico = ticketResuelto?.Usuario?.nombre?.trim() || "N/A";

  const ticketConVotacion = historial.find(item => item.votacion !== null && item.votacion !== undefined);
  const votacion = ticketConVotacion ? ticketConVotacion.votacion : null;

  return (
    <>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div className={styles.ticketBadge}>
            <FaTicketAlt />
            <span>#{ticket.TicketId}</span>
          </div>
          <div className={styles.statusIcon}>{estado.icon}</div>
        </div>

        <div className={styles.cardBody}>
          <div className={styles.infoRow}>
            <FaClock color="#94a3b8" />
            <span className={styles.label}>Activo:</span>
            <span className={styles.value}>{formatFecha(ticket.fecha)}</span>
          </div>

          <div className={styles.infoRow}>
            <FaUser color="#94a3b8" />
            <span className={styles.label}>Usuario:</span>
            <span className={styles.value}>{ticket.nombre || "N/A"}</span>
          </div>

          <div className={styles.infoRow}>
            <FaUserTie color="#3b82f6" />
            <span className={styles.label}>Técnico:</span>
            <span className={styles.value}>{nombreTecnico}</span>
          </div>

          <div className={styles.infoRow}>
            <FaStar color="#f59e0b" />
            <span className={styles.label}>Votación:</span>
            <span className={styles.value}>{votacion ? `${votacion} / 5` : "Pendiente"}</span>
          </div>
        </div>

        <button
          className={styles.detalleBtn}
          onClick={() => setShowModal(true)}
        >
          Explorar Detalles
        </button>
      </div>

      {/* ================= MODAL PRO ================= */}
      {showModal && (
        <div className={styles.modalOverlay} onClick={() => setShowModal(false)}>
          <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3><FaTicketAlt style={{ marginRight: '12px' }} /> Historial del Ticket #{ticket.TicketId}</h3>
              <FaTimes
                className={styles.closeIcon}
                onClick={() => setShowModal(false)}
              />
            </div>

            <div className={styles.modalContent}>
              {historial
                .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
                .map((item, index) => {
                  const itemEstado = getEstadoInfo(item.EstadoId);
                  return (
                    <div key={index} className={styles.detailCard}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', alignItems: 'center' }}>
                        <span style={{ fontSize: '0.75rem', fontWeight: '700', color: '#94a3b8' }}>
                          <FaClock style={{ marginRight: '6px' }} />
                          {formatFecha(item.fecha)}
                        </span>
                        <span style={{
                          padding: '4px 10px',
                          borderRadius: '6px',
                          fontSize: '0.7rem',
                          fontWeight: '800',
                          textTransform: 'uppercase',
                          background: 'rgba(241, 245, 249, 1)',
                          color: '#475569'
                        }}>
                          {itemEstado.descripcion}
                        </span>
                      </div>
                      <p style={{ margin: 0, lineHeight: '1.5', color: '#1e293b', fontSize: '0.9rem' }}>
                        {item.observacion}
                      </p>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Card;
